module.exports = "#likeModal .modal-dialog {\n  max-width: 400px;\n}\n\n.overlay {\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n}\n\n.modal-dialog.modal-dialog-centered {\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/like-modal/like-modal.component.css
// module id = ./src/app/shared/components/like-modal/like-modal.component.css
// module chunks = main